import { reminderSlice } from "./slice";

export const { newReminder, updateFilters, updateFiltersModal, clearStatus, clearFilters } = reminderSlice.actions

export default reminderSlice.reducer;
